import partner1 from "src/shared/assets/partners/partner1.png";
import partner2 from "src/shared/assets/partners/partner2.svg";
import partner3 from "src/shared/assets/partners/partner3.png";
import partner4 from "src/shared/assets/partners/partner4.png";
import partner5 from "src/shared/assets/partners/partner5.svg";
import partner6 from "src/shared/assets/partners/partner6.webp";
import partner7 from "src/shared/assets/partners/partner7.svg";
import partner8 from "src/shared/assets/partners/partner8.svg";
import partner9 from "src/shared/assets/partners/partner9.svg";
import partner10 from "src/shared/assets/partners/partner10.svg";
import partner11 from "src/shared/assets/partners/partner11.svg";
import partner12 from "src/shared/assets/partners/partner12.png";

export const partnersMarqueeData = [
  {
    alt: "Partner 1",
    image: partner1,
  },
  {
    alt: "Partner 2",
    image: partner2,
  },
  {
    alt: "Partner 3",
    image: partner3,
  },
  {
    alt: "Partner 4",
    image: partner4,
  },
  {
    alt: "Partner 5",
    image: partner5,
  },
  {
    alt: "Partner 6",
    image: partner6,
  },
  {
    alt: "Partner 7",
    image: partner7,
  },
  {
    alt: "Partner 8",
    image: partner8,
  },
  {
    alt: "Partner 9",
    image: partner9,
  },
  {
    alt: "Partner 10",
    image: partner10,
  },
  {
    alt: "Partner 11",
    image: partner11,
  },
  {
    alt: "Partner 12",
    image: partner12,
  },
];
